// React
import React, { useContext, forwardRef } from "react";

// Components
import Company from "./Company";
import AccountSettings from "./AccountSettings";
import { SettingsFlexBlocks } from "../Settings.styled";
import { StateUserContext } from "../../../../context/UserContext";
import { ACCESS_LEVEL, createRoleAccess } from "../../../routeAccess";

const Account = forwardRef((props, ref) => {
  const { user } = useContext(StateUserContext);
  const { hasAccess } = createRoleAccess(user?.role);

  return (
    <SettingsFlexBlocks>
      {hasAccess(ACCESS_LEVEL.owner) && <Company ref={ref.companyFormRef} />}
      <AccountSettings ref={ref.accountSettingsFormRef} />
    </SettingsFlexBlocks>
  );
});

export default Account;
